import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTableStatic from 'components/organisms/data-table-static'
import CmsFeaturedSellerLandingPageFsTableColumns from 'domains/cms-featured-seller/molecules/landing-page-fs-table-column'

const propTypes = {
  data           : PropTypes.array,
  hiddenColumns  : PropTypes.arrayOf(PropTypes.string),
  rowButtonProps : PropTypes.shape({
    buttonText       : PropTypes.string,
    buttonColour     : PropTypes.string,
    onButtonClick    : PropTypes.func,
    isButtonDisabled : PropTypes.bool
  })
}

const defaultProps = {
  data           : [],
  hiddenColumns  : [],
  rowButtonProps : {
    buttonText       : 'Remove',
    buttonColour     : 'danger',
    onButtonClick    : () => { alert('button clicked') },
    isButtonDisabled : false
  }
}

/**
 * Table to display Featured Sellers for specific landing page section
 * @param {Array<Object>} data - array of featured seller objects
 * @param {hiddenColumns} hiddenColumns - columns that hidden intentionally
 * @param {Object} rowButtonProps - props of rowButton
 */
const CmsFeaturedSellerLandingPageFsTable = ({
  data,
  hiddenColumns,
  rowButtonProps
}) => {

  const { buttonText, buttonColour, onButtonClick, isButtonDisabled } = rowButtonProps

  const columns = useMemo(
    () => CmsFeaturedSellerLandingPageFsTableColumns({
      buttonText,
      buttonColour,
      onButtonClick,
      isButtonDisabled
    }),
    [
      buttonColour,
      buttonText,
      onButtonClick,
      isButtonDisabled
    ]
  )

  return (
    <DataTableStatic
      data={ data }
      columns={ columns }
      hiddenColumns={ hiddenColumns }
      showPagination={ false }
      defaultPageSize={ 20 }
    />
  )
}

CmsFeaturedSellerLandingPageFsTable.propTypes    = propTypes
CmsFeaturedSellerLandingPageFsTable.defaultProps = defaultProps

export default CmsFeaturedSellerLandingPageFsTable
